import React from 'react'
import { makeStyles } from "@material-ui/core/styles";
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import IconButton from '@material-ui/core/IconButton';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import { Link, useHistory } from "react-router-dom";
import { useDrawerProvider } from '../../providers/DrawerContext';
import { actions } from '../../actions/drawer';

const useStyles = makeStyles((theme) => ({
    item: {
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        margin: '2px 10px 2px 0',
        borderRadius: '0 10px 10px 0',
        transition: 'background-color 0.15s ease',
        '&:hover': {
            backgroundColor: 'rgba(255,255,255,0.07)',
        },
        '&.Mui-selected': {
            backgroundColor: 'rgba(255,255,255,0.12)',
            borderLeft: '3px solid #ffeb00',
            paddingLeft: theme.spacing(1.625),
            '&:hover': {
                backgroundColor: 'rgba(255,255,255,0.15)',
            },
        },
    },
    subMenuItem: {
        paddingTop: theme.spacing(0.875),
        paddingBottom: theme.spacing(0.875),
        paddingLeft: theme.spacing(4),
        paddingRight: theme.spacing(2),
        margin: '1px 10px 1px 0',
        borderRadius: '0 10px 10px 0',
        transition: 'background-color 0.15s ease',
        '&:hover': {
            backgroundColor: 'rgba(255,255,255,0.07)',
        },
        '&.Mui-selected': {
            backgroundColor: 'rgba(255,255,255,0.12)',
            borderLeft: '3px solid #ffeb00',
            paddingLeft: `calc(${theme.spacing(4)}px - 3px)`,
            '&:hover': {
                backgroundColor: 'rgba(255,255,255,0.15)',
            },
        },
    },
    icon: {
        minWidth: 36,
        color: 'rgba(255,255,255,0.55)',
        justifyContent: drawer => drawer.openDesktop ? 'flex-start' : 'center',
        transition: 'color 0.15s ease',
        '& svg': {
            fontSize: '1.2rem',
        },
        '& .svg-inline--fa': {
            fontSize: '1rem',
        },
    },
    iconSelected: {
        color: '#ffffff',
    },
    menuText: {
        color: 'rgba(255,255,255,0.75)',
        fontSize: '0.875rem',
        fontWeight: 500,
        lineHeight: 1.3,
        fontFamily: "'Montserrat', 'Roboto', sans-serif",
    },
    menuTextSelected: {
        color: '#ffffff',
        fontWeight: 700,
    },
    expandButton: {
        color: 'rgba(255,255,255,0.4)',
        padding: 4,
        borderRadius: 6,
        '&:hover': {
            backgroundColor: 'rgba(255,255,255,0.1)',
            color: 'rgba(255,255,255,0.9)',
        },
    },
}));

export default function MenuItems({
    index,
    open,
    setOpen,
    route,
    isParentOfSubmenu = false,
    isSubMenu = false,
    updateRoute,
    mobileBreakpoint,
    nameOfOpenSubMenu
}) {

    const { state, dispatch } = useDrawerProvider();
    const classes = useStyles(state);
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.down(mobileBreakpoint));
    const history = useHistory();
    const subMenuNamePlusRoute = nameOfOpenSubMenu + route.path;
    const isOpen = open[index];
    const condition = state.openDesktop || matches;
    const isDisabled = isParentOfSubmenu && route.submenu && route.submenu.length === 0;
    const isSelected = history.location.pathname === route.path;

    const handleSubMenu = () => {
        const newMenuValues = [...open];
        newMenuValues[index] = !newMenuValues[index];
        setOpen(newMenuValues);
    };

    const handleUpdateRoute = (event, route) => {
        if (matches) dispatch({ type: actions.HANDLE_MENU, payload: !state.open });
        updateRoute(route);
    };

    const handleOnclick = event => handleUpdateRoute(event, route);

    return (
        <ListItem
            button
            className={
                isSubMenu
                    ? condition ? classes.subMenuItem : classes.item
                    : classes.item
            }
            selected={isSelected}
            component={Link}
            to={isParentOfSubmenu ? undefined : route.path}
            onClick={isParentOfSubmenu ? undefined : handleOnclick}
            key={route.path}
            disableFocusRipple={isParentOfSubmenu}
            disableRipple={isParentOfSubmenu}
            style={{ opacity: isDisabled ? 0.45 : 1 }}
        >
            <ListItemIcon className={`${classes.icon} ${isSelected ? classes.iconSelected : ''}`}>
                {route.icon}
            </ListItemIcon>
            {condition && (
                <ListItemText
                    classes={{
                        primary: `${classes.menuText} ${isSelected ? classes.menuTextSelected : ''}`,
                    }}
                    primaryTypographyProps={{ noWrap: false }}
                    primary={route.name}
                />
            )}
            {condition && (
                <ListItemSecondaryAction>
                    {route.submenu ? (
                        <IconButton
                            className={classes.expandButton}
                            onClick={() => handleSubMenu(subMenuNamePlusRoute)}
                            style={{ opacity: isDisabled ? 0.45 : 1 }}
                        >
                            {isOpen ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
                        </IconButton>
                    ) : null}
                </ListItemSecondaryAction>
            )}
        </ListItem>
    );
}
